module.exports = __webpack_public_path__ + "static/media/thumb-down-svgrepo-com (1).01e8fb67.svg";